"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import parse from "html-react-parser";
import Image from "next/image";
import Buttons from "@/components/static/Buttons";
import Button from "@/components/static/Button";
import { SectionProps, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";

type Content = {
    headline: HeadlineProps;
    text: string;
    image: ImageProps;
    settings: SectionProps;
    buttons: ButtonProps[];
};

export default function CTA_39({ content }: { content: Content }) {
    return (
        <Section dataComponent='CTA_39' settings={content.settings}>
            <div className='container'>
                <div className='grid grid-cols-1 bg-brand-light lg:grid-cols-2 items-center rounded-[30px] overflow-hidden'>
                    <div className='text-white px-12 py-18'>
                        <Headline tag={content.headline.tag} topline={content.headline.topline}>
                            <div className='{max-w-md margin-auto text-white font-medium'>
                                {content.headline.title}
                            </div>
                        </Headline>
                        <Text className='prose md:text-md text-white'>{parse(content.text)}</Text>
                        <div className='mt-6 flex flex-wrap items-center gap-4 md:mt-8'>
                            {content.buttons && (
                                <Buttons className='buttons gap-x-8 mt-8'>
                                    {content?.buttons?.map((button, index: number) => {
                                        return (
                                            <Button
                                                as='link'
                                                href={button?.link?.url ?? "#"}
                                                type={button?.type}
                                                key={index}
                                            >
                                                {button?.link?.title}
                                            </Button>
                                        );
                                    })}
                                </Buttons>
                            )}
                        </div>
                    </div>
                    <div className='overflow-hidden h-full'>
                        <Image
                            src={content.image.url}
                            height={content.image.height}
                            width={content.image.width}
                            alt={content.image.alt}
                            className='size-full object-cover object-center'
                        />
                    </div>
                </div>
            </div>
        </Section>
    );
}
